


export class TestGradient {

    // gradient=new LinearGradient("fanGroupTrapezoid0");
    // constructor() {
    //     document.addEventListener('keyup', (event) => {
    //         console.log("KeyShortcut_event.keyCode", event.keyCode);
    //         if (event.keyCode == 107) {//+
    //             this.gradient.getMode().repeatTime += 100;
    //             console.log("this.getMode().repeatTime", this.gradient.getMode().repeatTime);
    //         }
    //         if (event.keyCode == 109) {//-
    //             this.gradient.getMode().repeatTime -= 100;
    //             console.log("this.getMode().repeatTime", this.gradient.getMode().repeatTime);

    //         }
    //         if (event.keyCode == 84) {//T
    //             this.gradient.getMode().repeatTime = 30;
    //             console.log("this.getMode().repeatTime", this.gradient.getMode().repeatTime);

    //         }
    //         if (event.keyCode == 85) {//U
    //             this.gradient.getMode().repeatTime = 10;
    //             console.log("this.getMode().repeatTime", this.gradient.getMode().repeatTime);

    //         }
    //         console.log("KeyShortcut_event.keyCode", event.keyCode);
    //         if (event.keyCode == 13) {//Enter
    //             if (this.gradient.onPlay==false){
    //             }
    //             else{
    //             }
    //         }
    //         if (event.keyCode == 83){//S this.gradient.onPlay=false
                
    //         }     
    //         if (event.keyCode == 97){//1 this.gradient.onPlay=false

    //         }
    //         if (event.keyCode == 98){//2 this.gradient.onPlay=false
    //         }
    //         if (event.keyCode == 99){//3
    //         }
    //         if (event.keyCode == 100){//4
    //         }
    //         if (event.keyCode == 49){//Digit1
    //         }
    //         if (event.keyCode == 50){//Digit2
    //         }
    //         if (event.keyCode == 51){//Digit3
    //         }
    //         if (event.keyCode == 52){//Digit4
    //         }
    //         if (event.keyCode == 53){//Digit5
    //         }
    //         if (event.keyCode == 54){//Digit6
    //         }
    //         if (event.keyCode == 55){//Digit7
    //         }
    //         if (event.keyCode == 56){//Digit8

    //         }
    //         if (event.keyCode == 57){//Digit9

    //         }
    //         if (event.keyCode == 58){//Digit10

    //         }
    //         if (event.keyCode == 59){//Digit11

    //         }
    //     });
    // }


}


